<template>
    <div class="appointments-cancel">
        <div class="appointments-cancel__title">
            {{ title }}
        </div>

        <div class="appointments-cancel__actions">
            <STBaseButton :text="closeButtonText"
                          modify="button_theme_white button_size_small"
                          @click="close" />

            <STBaseButton :text="cancelButtonText"
                          icon-load="IconLoad"
                          :is-loading="isDeleting"
                          modify="button_size_small"
                          @click="submitRecordCancelling" />
        </div>
    </div>
</template>

<script>
import IconLoad from '@/components/Icons/Load';

export default {
    name: 'AppointmentsCancel',

    props: {
        cancelId  : [String, null],
        isDeleting: [Boolean]
    },

    computed: {
        title() {
            return this.cancelId ?
                'Вы уверены, что хотите отменить запись на презентацию?' :
                'Вы уверены, что хотите прервать запись на посещение офиса?';
        },

        closeButtonText() {
            return this.cancelId ? 'Вернуться назад' : 'Назад к записи';
        },

        cancelButtonText() {
            return this.cancelId ? 'Отменить запись' : 'Прервать запись';
        }
    },

    methods: {
        close() {
            this.$emit('close');
        },

        submitRecordCancelling() {
            this.$emit('submitRecordCancelling');
        }
    }
};
</script>

<style lang="scss">
@import "AppointmentsCancel";
</style>
